import React from 'react'

import type { TransitionProps } from '@mui/material/transitions'

import { Slide } from '@mui/material'

export function DialogTransition({ ref, ...props }: PropsWithRef<TransitionProps & { children: React.ReactElement }>) {
  return <Slide direction="up" ref={ref} {...props} />
}
